'use strict'

const LAUNCH_RDS_SUCCESS = 'LAUNCH_RDS_SUCCESS';
const LAUNCH_RDS_REQUEST = 'LAUNCH_RDS_REQUEST';
const LAUNCH_RDS_FAILURE = 'LAUNCH_RDS_FAILURE';
const LAUNCH_RDS_PROMPT = 'LAUNCH_RDS_PROMPT';
const RDS_CHECK_SUCCESS =  'RDSCheck_SUCCESS';
const RDS_CHECK_REQUEST =  'RDSCheck_REQUEST';
const RDS_CHECK_FAILURE =  'RDSCheck_FAILURE';
const RDS_DENIAL= 'RDS approval request was denied by the Lab Technician, kindly contact Lab Technician." with Ok Button'
const RDS_TIMEOUT= 'RDS approval request timed out, kindly contact Lab Technician'
const RDS_GENERIC_MESSAGE = 'RDS session cannot be established due to technical error, please contact DxS IntelliServe support.'
const SET_RDS_ACTION = "SET_RDS_ACTION";
const SET_FILESHARE_ACTION = "SET_FILESHARE_ACTION";
const RESET_FILESHARE_RDS_ACTION = "RESET_FILESHARE_RDS_ACTION";

export {
	LAUNCH_RDS_SUCCESS,
	LAUNCH_RDS_REQUEST,
	LAUNCH_RDS_FAILURE,
	LAUNCH_RDS_PROMPT,
	RDS_CHECK_SUCCESS,
	RDS_CHECK_REQUEST,
	RDS_CHECK_FAILURE,
	RDS_DENIAL,
	RDS_TIMEOUT,
	RDS_GENERIC_MESSAGE,
	SET_RDS_ACTION,
	SET_FILESHARE_ACTION,
	RESET_FILESHARE_RDS_ACTION
}